import { render } from "./UserDetailModal.vue?vue&type=template&id=4877eeab&scoped=true"
import script from "./UserDetailModal.vue?vue&type=script&lang=js"
export * from "./UserDetailModal.vue?vue&type=script&lang=js"

import "./UserDetailModal.vue?vue&type=style&index=0&id=4877eeab&scoped=true&lang=css"

import exportComponent from "/home/vueltaciclista/app/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4877eeab"]])

export default __exports__